import React from 'react'

const HelpEmail = () => (
    <span><a target='_blank' href='mailto:salessupport@bloombergindustry.com'>salessupport@bloombergindustry.com</a></span>
) 

export default HelpEmail